// Get and Set Firebase token with service Worker
/* eslint-disable */
import store from "@/store";
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

if (process.env.VUE_APP_NOTIFICATION == 1) {
  const firebaseConfig = {
    apiKey: "AIzaSyDMplU_BRdV29LVqlmX2amLkpJCGXCRces",
    authDomain: "mymirab-2a513.firebaseapp.com",
    projectId: "mymirab-2a513",
    storageBucket: "mymirab-2a513.firebasestorage.app",
    messagingSenderId: "845606491842",
    appId: "1:845606491842:web:7d6bdeeea8c7ef48374d5b",
  };

  initializeApp(firebaseConfig);
  // const analytics = getAnalytics(app);
  const messaging = getMessaging();
  onMessage(messaging, (payload) => {
    const msg =
      payload.notification.title + "<br/>" + payload.notification.body;
    store.commit("setInfo", msg);
    // console.log(analytics);
  });

  getToken(messaging, {
    vapidKey:
      "BNFZVgmif4WAfHcQ5zquVB7GpwzwAxkpDxnMWa1KV_GsyORpSGrmwjIRFklStNYf_O7F_PSewj7wynt9Ikst8Kg",
  })
    .then((currentToken) => {
      if (currentToken) {
        store.commit("setDeviceRegistrationToken", currentToken);
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
}
